// Book Assignment: the routes and the sidebar rows of `wealth.ops.book-assignment` (ADR-0027).
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';

const MoveClientBookAction = lazy(() =>
    import('./book-assignment.slots').then((m) => ({ default: m.MoveClientBookAction })),
);

export default defineWebFeature({
    id: 'wealth.ops.book-assignment',
    routes: [
        {
            frontend: 'ops',
            path: 'book-assignment',
            lazy: () => import('@/pages/ops/book-assignment/page'),
        },
        {
            frontend: 'comply',
            path: 'book-assignment',
            lazy: () => import('@/pages/comply/book-assignment/page'),
        },
    ],
    nav: [
        // Comply assigns a client to a book and corrects a wrong attribution
        // (SEP-232). It cannot move a whole book. Not `wip`: this page is finished.
        {
            frontend: 'comply',
            key: 'book-assignment',
            label: 'Book Assignment',
            href: '/comply/book-assignment',
            icon: 'BookUser',
            group: 'clients-kyc',
            order: 360,
        },
        // Which IM holds each client (SEP-232). Separate from Client Book, which
        // reads the directory and writes no attribution.
        {
            frontend: 'ops',
            key: 'book-assignment',
            label: 'Book Assignment',
            href: '/ops/book-assignment',
            icon: 'BookUser',
            group: 'client-operations',
            order: 430,
        },
    ],
    slots: {
        // "Move client to another book" on the Ops client record (SEP-302). It
        // moves the one client of the record, never a whole book.
        'client.detail.header-actions': [
            {
                key: 'move-client-book',
                order: 20,
                when: (ctx) => ctx.view === 'ops',
                Component: MoveClientBookAction,
            },
        ],
    },
});
